import gql from "graphql-tag";

// Staff props
const GlocuseStaffProps = gql`
    fragment GlocuseStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        email
        type {
            id
            name
        }
        designation {
            id
            name
        }
        department {
            id
            name
        }
        image
    }
`;

// GlucoseProps
const GlucoseProps = gql`
    fragment GlucoseProps on GlucoseMonitoring {
        id
        start
        end
        created_at
        active
        routines {
            id
            date
            comment
            result
            author {
                ...GlocuseStaffProps
            }
        }
        author {
            ...GlocuseStaffProps
        }
    }
    ${GlocuseStaffProps}
`;

const LIST = gql`
    query GetGlucoseMonitoringList($id: ID!) {
        GetGlucoseAssessments(id: $id) {
            docs {
                ...GlucoseProps
            }
        }
    }
    ${GlucoseProps}
`;

const CREATE = gql`
    mutation StartNewMonitoring($model: GlucoseMonitoringInput!) {
        StartNewGlucoseMonitoring(model: $model) {
            message
            doc {
                ...GlucoseProps
            }
        }
    }
    ${GlucoseProps}
`;

const ADD_ROUTINE = gql`
    mutation TakeGlucoseRoutine($id: ID!, $routine: GlucoseRoutineInput!) {
        TakeGlucoseRoutine(id: $id, routine: $routine) {
            message
            doc {
                ...GlucoseProps
            }
        }
    }
    ${GlucoseProps}
`;
export { LIST, CREATE, ADD_ROUTINE };
